var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFcMortgage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9546 15.925H12.9546C13.5546 15.925 13.9546 15.525 13.9546 14.925V7.925H14.9546C15.2546 7.925 15.5546 7.825 15.7546 7.625C16.1546 7.225 16.0546 6.625 15.6546 6.225L8.65464 0.225C8.25464 -0.075 7.75464 -0.075 7.35464 0.225L0.35464 6.225C-0.0453602 6.625 -0.14536 7.225 0.25464 7.625C0.35464 7.825 0.65464 7.925 0.95464 7.925C1.15464 7.925 1.95464 7.925 1.95464 7.925V14.925C1.95464 15.525 2.35464 15.925 2.95464 15.925H4.95464C5.55464 15.925 5.95464 15.525 5.95464 14.925V11.925H9.95464V14.925C9.95464 15.525 10.3546 15.925 10.9546 15.925Z",
    fill: "var(--fill-0, #86B4F9)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcMortgage);
export default __webpack_public_path__ + "static/media/fc-mortgage.b64de7059361938b3badaf5cbe4d4a91.svg";
export { ForwardRef as ReactComponent };